import { Component, OnInit } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { TranslateService } from "@ngx-translate/core";
import { ViewerMessageService } from "@viewer/core";
import { SynchroService } from "@viewer/core/synchro/synchro.service";

@Component({
  standalone: false,
  selector: "o-synchro-modal",
  templateUrl: "./synchro-modal.component.html",
  styleUrls: ["./synchro-modal.component.scss"]
})
export class SynchroModalComponent implements OnInit {
  constructor(
    private dialog: MatDialogRef<SynchroModalComponent>,
    private synchroService: SynchroService,
    private messageService: ViewerMessageService,
    private translate: TranslateService
  ) {}

  ngOnInit(): Promise<void> {
    return this.initSynchro();
  }

  /**
   * Start the synchronization and closes the modal once it's over.
   */
  private initSynchro(): Promise<void> {
    return this.synchroService.synchronize().then(() => {
      this.messageService.success(this.translate.instant("synchronize.ok"));
      this.dialog.close();
    });
  }
}
